import NotFound from "pages/sessions/NotFound";
import DashboardRoutes from "@/pages/dashboard/dashboard-route";
import sessionRoutes from "@/pages/sessions/session-routes";
import { Navigate } from "react-router-dom";
import AuthGuard from "../guards/auth-guard";
import UserRoutes from "@/pages/users/user-routes";
import TransactionRoutes from "@/pages/transactions/transaction-routes";
import SettlementRoutes from "@/pages/settlements/settlement-routes";
import InvoiceRoutes from "@/pages/invoices/invoice-routes";
import OTPRoutes from "pages/otp/OTPRoutes";
import TechRoutes from "@/pages/tech/tech-routes";
import LogRoutes from "@/pages/logs/log-routes";
import KycRoutes from "@/pages/kyc/kyc-routes";
import WayaOfficialRoutes from "pages/waya-official/WayaOfficialRoutes";
import PersistLogin from "@/guards/persist-login";
import DashboardLayout from "@/components/shared/app-layout/dashboard-layout";
import InternalReportingRoutes from "@/pages/internal-reporting/internal-reporting-routes";
import ProfileRoutes from "@/pages/profile/profile-routes";
import ProductRoutes from "@/pages/products/product-routes";
import ApprovalRoutes from "@/pages/approval/approval-routes";
import GlRoutes from "@/pages/gl-management/gl-routes";
import AdminPricingRoutes from "@/pages/admin-pricing/admin-pricing-routes";
import LedgerRoutes from "@/pages/ledger/ledger-routes";
import DisputeRoutes from "@/pages/disputes/dispute-routes";
import NotificationRoutes from "@/pages/notifications/notification-routes";

export const AllPages = () => {
  const all_routes = [
    {
      element: <PersistLogin />,
      children: [
        {
          element: (
            <AuthGuard>
              <DashboardLayout />
            </AuthGuard>
          ),
          children: [
            ...DashboardRoutes,
            ...UserRoutes,
            ...ProfileRoutes,
            ...TransactionRoutes,
            ...SettlementRoutes,
            ...DisputeRoutes,
            ...InvoiceRoutes,
            ...ApprovalRoutes,
            ...GlRoutes,
            ...LedgerRoutes,
            ...InternalReportingRoutes,
            ...KycRoutes,
            ...LogRoutes,
            ...OTPRoutes,
            ...AdminPricingRoutes,
            ...TechRoutes,
            ...ProductRoutes,
            ...WayaOfficialRoutes,
            ...NotificationRoutes,
          ],
        },
      ],
    },
    ...sessionRoutes,
    {
      path: "/",
      element: <Navigate to="/dashboard" />,
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ];

  return all_routes;
};
